import React from 'react';
import { ISeat, ISeatState, IWorkStation } from 'types/shared';
import { colorsConfig } from 'utils/colors';

interface WorkStationProps {
	seatStatesList: ISeatState[];
	workStation: IWorkStation;
	selectedSeat?: ISeat;
	onSelectSeat?: (seat: ISeat) => void;
	showSeatInfo?: (event: React.MouseEvent<SVGRectElement>, seat: ISeat) => void;
	hideSeatInfo?: () => void;
}

const WorkStation: React.FC<WorkStationProps> = ({
	seatStatesList,
	workStation,
	selectedSeat,
	onSelectSeat,
	showSeatInfo,
	hideSeatInfo,
}) => {
	const onSeatClick = (seat: ISeat) => {
		if (onSelectSeat && seat.seatStateId === 1) return onSelectSeat(seat);
	};

	return (
		<g>
			<rect
				x={workStation.x}
				y={workStation.y}
				width={workStation.width}
				height={workStation.height}
				rx="10"
				stroke={'#EFF0F2'}
				strokeWidth={3}
				fill={'#F8FAFD'}
			/>
			{workStation.seats.map((seat) => {
				const seatState =
					seat === selectedSeat ? 'Selected' : seatStatesList[seat.seatStateId - 1].name;

				return (
					<rect
						key={seat.id}
						x={seat.x}
						y={seat.y}
						width={seat.width}
						height={seat.height}
						rx="10"
						fill={colorsConfig[seatState].color}
						onClick={() => onSeatClick(seat)}
						onMouseOver={(event) => showSeatInfo && showSeatInfo(event, seat)}
						onMouseLeave={hideSeatInfo}
						cursor="pointer"
					/>
				);
			})}
		</g>
	);
};

export default WorkStation;
